export default __webpack_public_path__ + "static/media/user0.a45b4c4f.jpg";